import type { PropsWithChildren } from 'react'

export function SiteShell({ children }: PropsWithChildren) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' }}>
      {children}
    </div>
  )
}
